module.exports = __webpack_public_path__ + "static/img/part1.d67778b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/part1.png
// module id = 9Qxc
// module chunks = 96